import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _extends from 'babel-runtime/helpers/extends';
import _typeof from 'babel-runtime/helpers/typeof';
import warning from 'warning';
import { findIndex } from 'lodash';
import { SHOW_CHILD, SHOW_PARENT } from './strategies';

export function toArray(value) {
  var ret = value;
  if (value === undefined) {
    ret = [];
  } else if (!Array.isArray(value)) {
    ret = [value];
  }
  return ret;
}

export function getLabel(wrappedValue, node) {
  if (wrappedValue.label) {
    return wrappedValue.label;
  }

  if (node) {
    var props = node;
    if (Object.keys(props).length) {
      return props.label;
    }
  }

  // Since value without entity will be in missValueList.
  // This code will never reached, but we still need this in case.
  return wrappedValue.value;
}

// =================== Value ===================
/**
 * Convert value to array format to make logic simplify.
 */
export function formatInternalValue(value, _ref) {
  var uniqueKey = _ref.uniqueKey;

  var valueList = toArray(value);

  return valueList.map(function (val) {
    if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      return val;
    } else {
      return uniqueKey ? { key: val } : { value: val };
    }
  });
}

/** 计算树型数组层级 */
export function getArrayTreeDeep(data) {
  var children = data || [];
  var deep = 1;
  do {
    var foundItem = children.filter(function (item) {
      return item.children && item.children.length > 0;
    })[0];
    if (!foundItem) {
      break;
    }
    children = foundItem.children || [];
    deep += 1;
  } while (children.length > 0);
  return deep;
}

/** 由树形结构生成多级结构 */
export function arrayTreeFilter(data, filterFn) {
  var children = data || [];
  var result = [];
  var level = 0;
  do {
    var foundItem = children.filter(function (item) {
      return filterFn(item, level);
    })[0];
    if (!foundItem) {
      break;
    }
    result.push(foundItem);
    children = foundItem.children || [];
    level += 1;
  } while (children.length > 0);
  return result;
}

export function getPosition(level, index) {
  return level + '-' + index;
}

export function getNodeChildren() {
  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return children;
}

export function isCheckDisabled(node) {
  var _ref2 = node || {},
      disabled = _ref2.disabled,
      disableCheckbox = _ref2.disableCheckbox,
      checkable = _ref2.checkable;

  return !!(disabled || disableCheckbox) || checkable === false;
}

export function traverseTreeNodes(treeNodes, callback) {
  function processNode(node, index, parent) {
    var children = node ? node.children : treeNodes;
    var pos = node ? getPosition(parent.pos, index) : 0;

    // Filter children
    var childList = getNodeChildren(children);

    // Process node if is not root
    if (node) {
      var key = node.key;
      if (!key && (key === undefined || key === null)) {
        key = pos;
      }
      var data = {
        node: node,
        index: index,
        pos: pos,
        key: key,
        parentPos: parent.node ? parent.pos : null
      };
      callback(data);
    }

    // Process children node
    childList.filter(function (n) {
      return n;
    }).forEach(function (subNode, subIndex) {
      processNode(subNode, subIndex, { node: node, pos: pos });
    });
  }

  processNode(null);
}

/**
 * Use `rc-tree` convertTreeToEntities for entities calculation.
 * We have additional entities of `valueEntities`
 */
function initWrapper(wrapper) {
  return _extends({}, wrapper, {
    valueEntities: {}
  });
}

function processEntity(entity, wrapper, _ref3) {
  var unrelated = _ref3.unrelated,
      showCheckedStrategy = _ref3.showCheckedStrategy;
  var _entity$node = entity.node,
      value = _entity$node.value,
      children = _entity$node.children;

  entity.value = value;
  if (!unrelated && showCheckedStrategy === SHOW_CHILD && children && children.length) return;

  // This should be empty, or will get error message.
  var currentEntity = wrapper.valueEntities[value];
  if (currentEntity) {
    // warning(
    //   false,
    //   `Conflict! value of node '${entity.key}' (${value}) has already used by node '${currentEntity.key}'.`,
    // );
  } else {
    wrapper.valueEntities[value] = entity;
  }
}

export function convertTreeToEntities(treeNodes, props) {
  return vcConvertTreeToEntities(treeNodes, {
    initWrapper: initWrapper,
    processEntity: processEntity,
    props: props
  });
}

// TODO: ========================= NEW LOGIC =========================
/**
 * Calculate treeNodes entities. `processTreeEntity` is used for `rc-tree-select`
 * @param treeNodes
 * @param processTreeEntity  User can customize the entity
 */
export function vcConvertTreeToEntities(treeNodes) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      initWrapper = _ref4.initWrapper,
      processEntity = _ref4.processEntity,
      onProcessFinished = _ref4.onProcessFinished,
      _ref4$props = _ref4.props,
      props = _ref4$props === undefined ? {} : _ref4$props;

  var posEntities = new Map();
  var keyEntities = new Map();
  var wrapper = {
    posEntities: posEntities,
    keyEntities: keyEntities
  };

  if (initWrapper) {
    wrapper = initWrapper(wrapper) || wrapper;
  }

  traverseTreeNodes(treeNodes, function (item) {
    var node = item.node,
        index = item.index,
        pos = item.pos,
        key = item.key,
        parentPos = item.parentPos;

    var entity = { node: node, index: index, key: key, pos: pos };

    posEntities.set(pos, entity);
    keyEntities.set(key, entity);

    // Fill children
    entity.parent = posEntities.get(parentPos);
    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }

    if (processEntity) {
      var unrelated = props.unrelated,
          showCheckedStrategy = props.showCheckedStrategy;

      processEntity(entity, wrapper, { unrelated: unrelated, showCheckedStrategy: showCheckedStrategy });
    }
  });

  if (onProcessFinished) {
    onProcessFinished(wrapper);
  }

  return wrapper;
}

/**
 * Parse `checkedKeys` to { checkedKeys, halfCheckedKeys } style
 */
export function parseCheckedKeys(keys) {
  if (!keys) {
    return null;
  }

  // Convert keys to object format
  var keyProps = void 0;
  if (Array.isArray(keys)) {
    // [Legacy] Follow the api doc
    keyProps = {
      checkedKeys: keys,
      halfCheckedKeys: undefined
    };
  } else if ((typeof keys === 'undefined' ? 'undefined' : _typeof(keys)) === 'object') {
    keyProps = {
      checkedKeys: keys.checked || undefined,
      halfCheckedKeys: keys.halfChecked || undefined
    };
  } else {
    warning(false, '`checkedKeys` is not an array or an object');
    return null;
  }

  // keyProps.checkedKeys = keyListToString(keyProps.checkedKeys)
  // keyProps.halfCheckedKeys = keyListToString(keyProps.halfCheckedKeys)

  return keyProps;
}

/**
 * Conduct check state by the keyList. It will conduct up & from the provided key.
 * If the conduct path reach the disabled or already checked / unchecked node will stop conduct.
 * @param keyList       list of keys
 * @param isCheck       is check the node or not
 * @param keyEntities   parsed by `convertTreeToEntities` function in Tree
 * @param checkStatus   Can pass current checked status for process (usually for uncheck operation)
 * @returns {{checkedKeys: [], halfCheckedKeys: []}}
 */
export function conductCheck(keyList, isCheck, keyEntities) {
  var checkStatus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var checkedKeys = new Map();
  var halfCheckedKeys = new Map(); // Record the key has some child checked (include child half checked)

  (checkStatus.checkedKeys || []).forEach(function (key) {
    checkedKeys.set(key, true);
  });

  (checkStatus.halfCheckedKeys || []).forEach(function (key) {
    halfCheckedKeys.set(key, true);
  });

  // Conduct up
  function conductUp(key) {
    if (checkedKeys.get(key) === isCheck) return;

    var entity = keyEntities.get(key);
    if (!entity) return;

    var children = entity.children,
        parent = entity.parent,
        node = entity.node;


    if (isCheckDisabled(node)) return;

    // Check child node checked status
    var everyChildChecked = true;
    var someChildChecked = false; // Child checked or half checked

    (children || []).filter(function (child) {
      return !isCheckDisabled(child.node);
    }).forEach(function (_ref5) {
      var childKey = _ref5.key;

      var childChecked = checkedKeys.get(childKey);
      var childHalfChecked = halfCheckedKeys.get(childKey);

      if (childChecked || childHalfChecked) someChildChecked = true;
      if (!childChecked) everyChildChecked = false;
    });

    // Update checked status
    if (isCheck) {
      checkedKeys.set(key, everyChildChecked);
    } else {
      checkedKeys.set(key, false);
    }
    halfCheckedKeys.set(key, someChildChecked);

    if (parent) {
      conductUp(parent.key);
    }
  }

  // Conduct down
  function conductDown(key) {
    if (checkedKeys.get(key) === isCheck) return;

    var entity = keyEntities.get(key);
    if (!entity) return;

    var children = entity.children,
        node = entity.node;


    if (isCheckDisabled(node)) return;

    checkedKeys.set(key, isCheck);

    (children || []).forEach(function (child) {
      conductDown(child.key);
    });
  }

  function conduct(key) {
    var entity = keyEntities.get(key);

    if (!entity) {
      // warning(false, `'${key}' does not exist in the tree.`);
      checkedKeys.set(key, isCheck);
      return;
    }
    var children = entity.children,
        parent = entity.parent,
        node = entity.node;

    checkedKeys.set(key, isCheck);

    if (isCheckDisabled(node)) return;

    // Conduct down
    (children || []).filter(function (child) {
      return !isCheckDisabled(child.node);
    }).forEach(function (child) {
      conductDown(child.key);
    });

    // Conduct up
    if (parent) {
      conductUp(parent.key);
    }
  }

  (keyList || []).forEach(function (key) {
    conduct(key);
  });

  var checkedKeyList = [];
  var halfCheckedKeyList = [];

  // Fill checked list
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = checkedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref6 = _step.value;

      var _ref7 = _slicedToArray(_ref6, 2);

      var key = _ref7[0];
      var value = _ref7[1];

      if (value) {
        checkedKeyList.push(key);
      }
    }

    // Fill half checked list
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = halfCheckedKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref8 = _step2.value;

      var _ref9 = _slicedToArray(_ref8, 2);

      var _key = _ref9[0];
      var _value = _ref9[1];

      if (!checkedKeys.get(_key) && _value) {
        halfCheckedKeyList.push(_key);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
        _iterator2['return']();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return {
    checkedKeys: checkedKeyList,
    halfCheckedKeys: halfCheckedKeyList
  };
}

/**
 * Convert position list to hierarchy structure.
 * This is little hack since use '-' to split the position.
 */
export function flatToHierarchy(positionList) {
  if (!positionList.length) {
    return [];
  }

  var entrances = {};

  // Prepare the position map
  var posMap = {};
  var parsedList = positionList.slice().map(function (entity) {
    var clone = _extends({}, entity, {
      fields: entity.pos.split('-')
    });
    delete clone.children;
    return clone;
  });

  parsedList.forEach(function (entity) {
    posMap[entity.pos] = entity;
  });

  parsedList.sort(function (a, b) {
    return a.fields.length - b.fields.length;
  });

  // Create the hierarchy
  parsedList.forEach(function (entity) {
    var parentPos = entity.fields.slice(0, -1).join('-');
    var parentEntity = posMap[parentPos];

    if (!parentEntity) {
      entrances[entity.pos] = entity;
    } else {
      parentEntity.children = parentEntity.children || [];
      parentEntity.children.push(entity);
    }

    // Some time position list provide `key`, we don't need it
    delete entity.key;
    delete entity.fields;
  });

  return Object.keys(entrances).map(function (key) {
    return entrances[key];
  });
}

/**
 * Convert internal state `valueList` to user needed value list.
 * This will return an array list. You need check if is not multiple when return.
 *
 * `allCheckedNodes` is used for `treeCheckStrictly`
 */
export function formatSelectorValue(valueList, props, keyEntities, valueEntities) {
  var unrelated = props.unrelated,
      showCheckedStrategy = props.showCheckedStrategy;

  // Will hide some value if `showCheckedStrategy` is set

  if (!unrelated) {
    var values = {};
    valueList.forEach(function (wrappedValue) {
      values[wrappedValue.key] = wrappedValue;
    });
    /** value有可能有重复值，所以改成用key来生成已选树
     * 后来出现只需要value匹配中就能生成已选树的情况
     */
    // const startTime = Date.now();
    var hierarchyList = flatToHierarchy(valueList.map(function (_ref10) {
      var key = _ref10.key,
          value = _ref10.value;
      return keyEntities.get(key) || valueEntities && valueEntities[value];
    }));
    // console.log('flatToHierarchy', Date.now() - startTime, hierarchyList);

    if (showCheckedStrategy === SHOW_PARENT) {
      // Only get the parent checked value
      return hierarchyList.map(function (_ref11) {
        var node = _ref11.node;

        var value = node.value,
            label = node.label,
            key = node.key,
            rest = _objectWithoutProperties(node, ['value', 'label', 'key']);

        return _extends({}, rest, {
          label: label,
          value: value,
          key: key
        });
      });
    }
    if (showCheckedStrategy === SHOW_CHILD) {
      // Only get the children checked value
      var targetValueList = [];

      // Find the leaf children
      var traverse = function traverse(_ref12) {
        var node = _ref12.node,
            children = _ref12.children;

        var value = node.value,
            label = node.label,
            key = node.key,
            rest = _objectWithoutProperties(node, ['value', 'label', 'key']);

        if (!children || children.length === 0) {
          targetValueList.push(_extends({}, rest, {
            label: label,
            value: value,
            key: key
          }));
          return;
        }

        children.forEach(function (entity) {
          traverse(entity);
        });
      };

      hierarchyList.forEach(function (entity) {
        traverse(entity);
      });

      return targetValueList;
    }
  }

  return valueList.map(function (wrappedValue) {
    var node = keyEntities.get(wrappedValue.key).node || {};

    var value = node.value,
        key = node.key,
        rest = _objectWithoutProperties(node, ['value', 'key']);

    return _extends({
      label: getLabel(wrappedValue, node),
      value: value,
      key: key
    }, rest);
  });
}

export var getCheckedNodes = function getCheckedNodes(data) {
  var checked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();

  var checkedNodes = [];
  var children = Array.isArray(data) ? data : [data];
  for (var i in children) {
    var item = children[i];
    var son = item.children || [];
    if (son.length === 0) {
      if (item.key && (checked.has(item.value) || checked.has('' + item.value) || checked.has(item.key))) {
        checkedNodes.push({
          key: item.key,
          value: item.value,
          label: item.label
        });
      }
    }
    if (son && son.length) {
      checkedNodes = checkedNodes.concat(getCheckedNodes(son, checked));
    }
  }
  return checkedNodes;
};

/**
 * Get a filtered TreeNode list by provided treeNodes.
 * [Legacy] Since `Tree` use `key` as map but `key` will changed by React,
 * we have to convert `treeNodes > data > treeNodes` to keep the key.
 * Such performance hungry!
 */
export function getFilterTree(treeNodes, searchValue, filterFunc) {
  if (!searchValue) {
    return null;
  }

  function mapFilteredNodeToData(node) {
    if (!node) return null;

    var match = false;
    if (filterFunc(searchValue, node)) {
      match = true;
    }
    var children = node.children;
    children = (children || []).map(mapFilteredNodeToData).filter(function (n) {
      return n;
    });
    if (children.length || match) {
      return _extends({}, node, {
        children: children
      });
    }

    return null;
  }
  return treeNodes.map(mapFilteredNodeToData).filter(function (node) {
    return node;
  });
}

export function flattenTreeNodes(data) {
  var ret = [];
  (data || []).forEach(function (item) {
    if (Array.isArray(item)) {
      ret = ret.concat(flattenTreeNodes(item));
    } else {
      var value = item.value,
          label = item.label,
          children = item.children;

      if (children && children.length > 0) {
        ret = ret.concat(flattenTreeNodes(children));
      } else {
        ret.push({ value: value, label: label });
      }
    }
  });
  return ret;
}

function buildNewItems(renderData, newData) {
  var newItems = [];
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = newData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var newRecord = _step3.value;

      if (findIndex(renderData, { key: newRecord.key }) < 0) {
        newItems.push(newRecord);
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3['return']) {
        _iterator3['return']();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return newItems;
}

function buildOutDataItems(renderData, newData) {
  var replaceItemsIndex = [];
  for (var index in renderData) {
    if (findIndex(newData, { key: renderData[index].key }) < 0) {
      replaceItemsIndex.push(index);
    }
  }
  return replaceItemsIndex;
}

function refreshSelectorItems(renderData, newItems, replaceItemsIndex) {
  var count = 0;
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = replaceItemsIndex[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var index = _step4.value;

      renderData.splice(index - count, 1);
      count++;
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4['return']) {
        _iterator4['return']();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return renderData.concat(newItems);
}

export function updateCheckedNodes(renderData, newData, reload) {
  if (renderData.length === 0 || reload === true) {
    return newData;
  }
  var newItems = buildNewItems(renderData, newData);
  var replaceItemsIndex = buildOutDataItems(renderData, newData);
  return refreshSelectorItems(renderData, newItems, replaceItemsIndex);
}

export function updateSelectorNodes(oldNodes, newNodes) {
  if (oldNodes === undefined) return oldNodes;
  return oldNodes.map(function (item) {
    var index = findIndex(newNodes, { value: item.value });
    if (index > -1) {
      return newNodes[index];
    }
    return item;
  });
}

export function getOffsetTop(element, container) {
  if (!element) {
    return 0;
  }

  if (!element.getClientRects().length) {
    return 0;
  }

  var rect = element.getBoundingClientRect();

  if (rect.width || rect.height) {
    if (container === window) {
      container = element.ownerDocument.documentElement;
      return rect.top - container.clientTop;
    }
    return rect.top - container.getBoundingClientRect().top;
  }

  return rect.top;
}

export function isPosRelated(pos1, pos2) {
  var fields1 = pos1.split('-');
  var fields2 = pos2.split('-');

  var minLen = Math.min(fields1.length, fields2.length);
  for (var i = 0; i < minLen; i += 1) {
    if (fields1[i] !== fields2[i]) {
      return false;
    }
  }
  return true;
}

export function keyBy(arr, key) {
  if (!arr || !Array.isArray(arr) || !key) return [];
  var obj = {};
  for (var i in arr) {
    var item = arr[i];
    obj[item[key]] = item;
  }
  return obj;
}